const drawer = {
  baseStyle: {
    dialog: {
      // Mesmo motivo do modal: o padrão escuro do Chakra é gray.700 (azulado).
      _dark: { "--drawer-bg": "colors.app-sidebar" },
    },
  },
};

export default drawer;
